import { useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

// Global 402 interceptor — when a subscription expires, clear auth and reload
// so the user lands on login with a message instead of seeing broken data.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 402) {
      const code = error.response.data?.code;
      const msg =
        code === 'SUBSCRIPTION_CANCELLED'
          ? 'Your subscription has been cancelled. Please contact support.'
          : 'Your free trial has expired. Please upgrade to continue.';
      // Don't redirect from the subscription-status call itself
      if (!error.config?.url?.includes('/subscription/status')) {
        alert(msg);
        Cookies.remove('AuthToken');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const App = () => (
  <ThemeCustomization>
    <ScrollTop>
      <Routes />
    </ScrollTop>
  </ThemeCustomization>
);

export default App;
